module.exports = __webpack_public_path__ + "img/extensionAndVideo.84824146.svg";